<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-4 col-4">
                    <h2>DAILY BIDS HISTORY</h2>
                    </div>
                    <div class="col-lg-8 col-8 text-right">                       
                        <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2">
                            <i @click="searchTrader()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                            <input v-on:keyup.enter="searchTrader" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search" aria-label="Search">
                            <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form> 
        
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6 filter-show">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-2">
                      <label for="filter" class="">From</label>
                      <datepicker :disabledDates="disabledDates" v-model="fromDate"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-2">
                      <label for="filter" class="">To</label>
                      <datepicker :disabledDates="disabledDates" v-model="toDate"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="col-md-6 col-lg-3">
                    <button @click="clear()" type="button" class="btn btn-secondary rounded mt-4">Clear</button>
                    <button @click="searchTrader()" type="button" class="btn btn-primary rounded mt-4">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr >
                              <th 
                                    scope="col" 
                                    class="sort text-center"
                                >date</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                                    @click="sort('firstName')" >TRADER</th>
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'idcPullCount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'idcPullCount'  ? 'sort-desc' : '']"  
                                    @click="sort('idcPullCount')" >IDC COUNT</th> 
                                    <th 
                                    scope="col" 
                                    class="sort text-center"
                                     >ASSIGNED COUNT</th>   
                                         
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >total suggested <span class="hint" data-toggle="tooltip" data-placement="left"  title="The total number of bids suggested for the trader.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i>
              </span>  </th> 
                                  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >Suggested Price Count <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of bids sent at the suggested price.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span> </th>   
                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >Bid Count <span class="hint" data-toggle="tooltip" data-placement="left"  title="The total number of bids sent by the trader.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i> </span></th>  
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >changed Bid Count <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of bids sent after changing the suggested price.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span></th>   
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >rejected <span class="hint" data-toggle="tooltip" data-placement="left"  title="The number of suggested bids that are not sent.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span></th> 
                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >executed Bid Count 
                                <span class="hint" data-toggle="tooltip" data-placement="left"  title="The count of executed bids.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span></th>
                <th 
                                    scope="col" 
                                    class="sort text-center"
                                >fill Rate <span class="hint" data-toggle="tooltip" data-placement="left"  title="The ratio of traded items to the number of bids sent.">
                <i class="fa fa-info-circle" style="color: #ffa300"></i></span> </th>  
                                                     
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="totalRows == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="trader in traders" :key="trader.id">
                                <td class="text-center">{{trader.createdDate ? moment(trader.createdDate).format("MM/DD/YYYY, h:mm:ss a") : 'N/A'}}</td>
                                <td class="text-center">{{trader.firstName }} {{trader.lastName}}</td>
                                <td class="text-center">{{trader.idcPullCount}}</td>
                                <td class="text-center">{{trader.assignedCount}}</td>
                                <td class="text-center">{{trader.totalSuggestedCount}}</td>
                                <td class="text-center">{{trader.doneAtSuggestedPriceCount}}</td>
                                <td class="text-center">{{trader.doneBidCount}}</td>
                                <td class="text-center">{{trader.changedBidCount}}</td>
                                <td class="text-center">{{trader.rejected}}</td>
                                <td class="text-center">{{trader.executedBidCount}}</td>
                                <td class="text-center" >
                                  <span v-if="trader.doneBidCount">{{convertToPercentage(trader.fillRate)}}</span>
                                </td>
                               
                            </tr>
                            </tbody>
                        </table>
                        <!-- Pagination-->
                        <b-pagination
                            class="mt-4"
                            :total-rows="totalRows"
                            v-model="currentPage"
                            :per-page="perPage"
                            @input="getTraderList(currentPage)"
                        ></b-pagination>
                        <div class="total-records">
                            <span>Total Records : {{totalRows}}</span>
                        </div>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
       
    </div>      
</template>
<script>

import config from "@/config";
import authService from "@/authService";
import Datepicker from 'vuejs-datepicker';

export default {
  name: "imstradersComponent",
  components : {
    Datepicker
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 10,
        searchValue : "",
        totalRows : 0,
        sortColumn: "firstName",
        sortOrder: "ASC",
        traderData : null,
        traderEditModalOpen : false,
        traders : [],
        accountList : [],
        isAdmin: false,
        isTrader : false,
        isEditor : false,
        isSuperAdmin : false,
        showFilters : true,
        fromDate : "",
        toDate : "",
        disabledDates: {
            from: new Date(new Date() - 86400000)
        }
     
    };
  },
  methods: {
    searchTrader(){
        this.getTraderList();
    },
    clear(){
      this.fromDate = this.moment().subtract(1,'days').format("MM-DD-YYYY"); 
      this.toDate = this.moment().format("MM-DD-YYYY");
      this.getTraderList();
    },
    clearSearch(){
        this.searchValue = "";
        this.getTraderList();
    },
    sort(column){
        this.sortColumn = column;
        this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
        this.getTraderList();
    },
    getTraderList(){
        this.loading = true;
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        var fDate = this.fromDate ? this.moment(this.fromDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        var tDate = this.toDate ?  this.moment(this.toDate).utc().format("YYYY-MM-DD HH:mm:ss") : "";
        this.$http
        .get(
          config.baseUrlAutoBidder +
            "/autobidder/bid-count-log?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder +
            "&fromDate="+
            fDate+
            "&toDate="+
            tDate,
          auth
        )
        .then(result => {
          this.totalRows = result.data.pageInfo.totalElements;
          this.traders = result.data.content;
          this.loading = false;
        })
    },
  },
  mounted() {
    this.fromDate = this.moment().subtract(1, 'days').format("MM-DD-YYYY");
    this.toDate = this.moment().format("MM-DD-YYYY"); 
    this.getTraderList();
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
    });
  }
};
</script>